/**
 * PATH: packages/ui/src/components/settings/AllKanbanSettingsTab.tsx
 * FILE_ID: UI-SETTINGS-ALL-KANBAN-TAB-001
 * PURPOSE: Gear-menu All Kanban tab so Settings works without an open board.
 * ROLE IN ARCHITECTURE: @quotech/ui Settings modal body over settings-home frames.
 * MAIN EXPORTS: AllKanbanSettingsTab
 * NON-RESPONSIBILITIES: Does not own This-board pages or mint a prefs API.
 * NOTES FOR FUTURE AI: resolveKanbanSettingsHost binds the boot API
 *   provider when SettingsHome has not mounted. Do not require /kanban first.
 */

import { useState } from 'react'

import { getSettingsHubConfig } from '@quotech/tenant-shared/settings/settingsHubConfig'

import {
  AllKanbanSettingsFrames,
  requestKanbanShortcutsOpen,
  resolveKanbanSettingsHost,
  useKanbanChromePrefs,
  type SettingsCapabilities,
  type SettingsPage,
} from '../../kanban/components/settings-home'

export function AllKanbanSettingsTab({
  userId,
  organisationId,
}: {
  userId?: string | number | null
  organisationId?: string | number
}) {
  const config = getSettingsHubConfig()
  const host = resolveKanbanSettingsHost(organisationId)
  const [page, setPage] = useState<SettingsPage>('kanban-face')
  const { cardDensity, setCardDensity, keyboardMode, setKeyboardMode } = useKanbanChromePrefs()

  if (!config.showAllKanbanTab) {
    return (
      <p data-testid="settings-all-kanban-unavailable" className="text-sm text-neutral-500">
        All Kanban settings are not enabled for this host.
      </p>
    )
  }

  const capabilities: SettingsCapabilities = {
    canManageBoard: false,
    canManageMembers: false,
    hasBoardContext: false,
    hasEmailSettings: Boolean(config.emailSettingsHref),
    hasOrganisationSettings: Boolean(config.organisationSettingsHref),
  }

  return (
    <div data-testid="settings-all-kanban-tab">
      <AllKanbanSettingsFrames
        page={page}
        onPage={setPage}
        capabilities={capabilities}
        userId={userId ?? null}
        api={host?.api}
        organisationId={host?.organisationId}
        cardDensity={cardDensity}
        setCardDensity={setCardDensity}
        keyboardMode={keyboardMode}
        setKeyboardMode={setKeyboardMode}
        setShortcutsOpen={() => {
          requestKanbanShortcutsOpen()
        }}
        onClose={() => {}}
        embedded
      />
    </div>
  )
}
